export default __webpack_public_path__ + "static/media/google_round.1fb4cfe9.svg";